// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"936d86f0","977":"35cda233"}[chunkId] + ".chunk.js";
};